import React, { useEffect, useState } from 'react';

import PropTypes from 'prop-types';
import { AvForm } from 'availity-reactstrap-validation';

import { Row, Nav, NavItem, NavLink, TabContent, TabPane } from 'reactstrap';

import BasicPills from '../../components/Common/BasicPills/BasicPills';
import POcomparison from '../../components/Common/POComparision/POcomparison';
import { useDispatch } from 'react-redux';

const IForm = ({
  selectedRow,
  milestoneConfig,
  groupName,
  onCreate,
  onUpdate,
  onDelete,
}: any) => {
  const dispatch = useDispatch();

  const arrayUpdAdd = [
    'BuyerName',
    'Number',
    'company',
    'description',
    'enabled',
  ];
  const columsPop = 4;
  const toggleField = 'enabled';

  const [form, setForm] = useState({ [toggleField]: false });
  const [optionSelect, setSelectOption] = useState<any>({});

  const [listVisibleInModalHeader, setlistVisibleInModalHeader] = useState([
    {},
  ]);
  const [listVisibleInModalBody, setlistVisibleInModalBody] = useState([{}]);
  const [listVisibleInModalTotal, setlistVisibleInModalTotal] = useState([{}]);

  const [listVisibleInMiddle, setlistVisibleInMiddle] = useState([{}]);
  const [listVisibleInModalFooter, setlistVisibleInModalFooter] = useState([
    {},
  ]);
  const [listIsMilestones, setlistIsMilestones] = useState([{}]);

  const [isPurchaseOrderView, setPurchaseOrderView] = useState<boolean>(false);
  const [tabPurchaseView, setTabPurchaseView] = useState<string>('1');

  useEffect(() => {
    if (selectedRow) {
      setSelectOption(selectedRow);
      setForm(selectedRow);
    }
  }, [selectedRow]);

  useEffect(() => {
    if (groupName === 'purchaseOrdersViewList') setPurchaseOrderView(true);
  }, [groupName]);

  useEffect(() => {
    if (milestoneConfig) {
      const middle = milestoneConfig.filter(
        (x: { visibleInMiddle: boolean }) => x.visibleInMiddle === true,
      );
      const modalBody = milestoneConfig.filter(
        (x: { visibleInModalBody: boolean }) => x.visibleInModalBody === true,
      );
      const modalFooter = milestoneConfig.filter(
        (x: { visibleInModalFooter: boolean }) =>
          x.visibleInModalFooter === true,
      );
      const modalHeader = milestoneConfig.filter(
        (x: { visibleInModalHeader: boolean }) =>
          x.visibleInModalHeader === true,
      );
      const modalTotal = milestoneConfig.filter(
        (x: { visibleInModalTotal: boolean }) => x.visibleInModalTotal === true,
      );
      const isMilestone = milestoneConfig.filter(
        (x: { isMilestone: boolean }) => x.isMilestone === true,
      );

      setlistVisibleInMiddle(processList(middle, selectedRow));
      setlistVisibleInModalBody(processList(modalBody, selectedRow));
      setlistVisibleInModalFooter(processList(modalFooter, selectedRow));
      setlistVisibleInModalHeader(processList(modalHeader, selectedRow));
      setlistVisibleInModalTotal(processList(modalTotal, selectedRow));
      setlistIsMilestones(processList(isMilestone, selectedRow));
    }
  }, [milestoneConfig]);

  const processList = (list: any[], selectedRow: any) => {
    const t: any[] = [];
    for (const item in selectedRow) {
      list.map(function (data: { dataField: string }, index: any) {
        if (data.dataField === item)
          t.push({
            ...data,
            value: selectedRow[item],
          });
        return data;
      });
    }

    return t;
  };

  const itemVals = (val: any, updateVal: any) => {
    for (const property in updateVal) {
      if (property === val) {
        return updateVal[property];
      }
    }
  };

  const renderModalHeader = () => {
    return (
      <React.Fragment>
        {listVisibleInModalHeader.length
          ? listVisibleInModalHeader.map((item: any, key: any) => {
            const { text, value } = item;
            if (value != '' && value != null) {
              return (
                <div>
                  <label className="labelModalHeader"> {text} </label>
                  <label className="labelInfoModal"> {value}</label>
                </div>
              );
            }
          })
          : null}
      </React.Fragment>
    );
  };

  const renderInModalTotal = () => {
    return (
      <React.Fragment>
        {listVisibleInModalTotal.length
          ? listVisibleInModalTotal.map((item: any, key: any) => {
            const { text, value } = item;
            if (value != '' && value != null) {
              return (
                <div>
                  <label className="labelTotalPieces">
                    {' '}
                    {text} : {value}{' '}
                  </label>
                </div>
              );
            }
          })
          : null}
      </React.Fragment>
    );
  };

  const renderInModalBody = () => {
    return (
      <React.Fragment>
        {listVisibleInModalBody.length
          ? listVisibleInModalBody.map((item: any, key: any) => {
            const { text, value } = item;
            if (value != '' && value != null) {
              return (
                <div>
                  <label className="labelModal"> {text} </label>
                  <label className="labelInfoModal"> {value}</label>
                </div>
              );
            }
          })
          : null}
      </React.Fragment>
    );
  };

  return (
    <>
      <div className="formContainer">
        {isPurchaseOrderView ? (
          <div style={{ width: '100%' }}>
            <Nav horizontal="end" tabs>
              <NavItem>
                <NavLink
                  className={`${tabPurchaseView === '1' ? 'active' : ''} btn`}
                  onClick={() => setTabPurchaseView('1')}
                >
                  <i className="bi bi-info-circle pe-1"></i> Info
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  className={`${tabPurchaseView === '2' ? 'active' : ''} btn`}
                  onClick={() => setTabPurchaseView('2')}
                >
                  <i className="bi bi-boxes pe-1"></i> PO/WR Comparison
                </NavLink>
              </NavItem>
            </Nav>
            <TabContent activeTab={tabPurchaseView}>
              <TabPane tabId="1">
                <Row className="upRown">
                  <AvForm
                    className="custom-form mt-0"
                    style={{
                      display: 'grid',
                      gridTemplateColumns: `repeat(${columsPop}, 1fr)`,
                      gridAutoRows: 'minmax(10%, 60px)',
                      gridGap: '2%',
                      padding: '0',
                      textAlign: 'center',
                    }}
                  >
                    {listVisibleInModalHeader.length
                      ? renderModalHeader()
                      : null}
                  </AvForm>
                </Row>
                <Row className="MiddleRown">
                  <BasicPills data={listIsMilestones} />
                </Row>

                <Row className="DownRown">
                  <AvForm
                    className="custom-form mt-0"
                    style={{
                      display: 'grid',
                      gridTemplateColumns: `repeat(${columsPop}, 1fr)`,
                      gridAutoRows: 'minmax(10%, 50px)',
                      gridGap: '2%',
                      padding: '0',
                    }}
                  >
                    {listVisibleInModalBody.length ? renderInModalBody() : null}
                  </AvForm>
                </Row>

                <Row
                  className="rowTotalPieces"
                  style={{
                    padding: '0',
                    textAlign: 'center',
                  }}
                >
                  {listVisibleInModalTotal.length ? renderInModalTotal() : null}
                </Row>
              </TabPane>
              <TabPane tabId="2">
                <POcomparison
                  selectedRow={selectedRow}
                  milestoneConfig={milestoneConfig}
                  isActive={tabPurchaseView === '2'}
                />
              </TabPane>
            </TabContent>
          </div>
        ) : (
          <>
            <Row className="upRown">
              <AvForm
                className="custom-form mt-0"
                style={{
                  display: 'grid',
                  gridTemplateColumns: `repeat(${columsPop}, 1fr)`,
                  gridAutoRows: 'minmax(10%, 60px)',
                  gridGap: '2%',
                  padding: '0',
                  textAlign: 'center',
                }}
              >
                {listVisibleInModalHeader.length ? renderModalHeader() : null}
              </AvForm>
            </Row>
            <Row className="MiddleRown">
              <BasicPills data={listIsMilestones} />
            </Row>

            <Row className="DownRown">
              <AvForm
                className="custom-form mt-0"
                style={{
                  display: 'grid',
                  gridTemplateColumns: `repeat(${columsPop}, 1fr)`,
                  gridAutoRows: 'minmax(10%, 80px)',
                  gridGap: '2%',
                  padding: '0',
                }}
              >
                {listVisibleInModalBody.length ? renderInModalBody() : null}
              </AvForm>
            </Row>

            <Row
              className="rowTotalPieces"
              style={{
                padding: '0',
                textAlign: 'center',
                maxHeight: 100,
                overflow: 'auto',
              }}
            >
              {listVisibleInModalTotal.length ? renderInModalTotal() : null}
            </Row>
          </>
        )}
      </div>
    </>
  );
};

IForm.propTypes = {
  selectedRow: PropTypes.shape({
    Number: PropTypes.string,
    SellerName: PropTypes.string,
  }),
  milestoneConfig: PropTypes.shape({
    Number: PropTypes.string,
    SellerName: PropTypes.string,
    OperationName: PropTypes.string,
    OperationType: PropTypes.string,
    dataField: PropTypes.string,
    isMilestone: PropTypes.bool,
    order: PropTypes.string,
    text: PropTypes.string,
    userId: PropTypes.string,
    visibleInMiddle: PropTypes.bool,
    visibleInModalFooter: PropTypes.bool,
    visibleInModalHeader: PropTypes.bool,
    visibleInTable: PropTypes.bool,
    hidden: PropTypes.bool,
    visibleInModalBody: PropTypes.bool,
    visibleInModalTotal: PropTypes.bool,
  }),
  groupName: PropTypes.string,
  onCreate: PropTypes.func,
  onUpdate: PropTypes.func,
  onDelete: PropTypes.func,
};

type Operations = {
  id?: number;
  Number?: string;
};

export default IForm;
